/**
 *  output: YYYYMMDD // 20211231
 */
export const makeDatePrefix = () => new Date().toLocaleDateString().split(/[\/.]/g).reverse().join('');
